@let onglet = data()?.ongletDevPsychomoteur ?? null;

@let itemsMotGlobale = getVisibleItems(onglet?.checkbox_motriciteGobale, motriciteGlobaleLabels, 'checkbox_motriciteGobale');
@if (itemsMotGlobale.length) {
<p class="section-sub-title"><mat-icon>directions_walk</mat-icon>Motricité globale</p>
<div class="chips-block">
  @for (e of itemsMotGlobale; track e.key) {
  @let daDate = getFirstDate('checkbox_motriciteGobale', e.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="daDate"
    #tt="matTooltip"
    [matTooltip]="daDate ? 'Depuis le ' + formatFirstDate(daDate) : ''"
    matTooltipPosition="above"
    (click)="daDate && tt.show()">{{ e.label }}</mat-chip>
  }
</div>
}

@let itemsMotFine = getVisibleItems(onglet?.checkbox_motriciteFine, motriciteFineLabels, 'checkbox_motriciteFine');
@if (itemsMotFine.length) {
<p class="section-sub-title"><mat-icon>front_hand</mat-icon>Motricité fine</p>
<div class="chips-block">
  @for (e of itemsMotFine; track e.key) {
  @let daDate = getFirstDate('checkbox_motriciteFine', e.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="daDate"
    #tt="matTooltip"
    [matTooltip]="daDate ? 'Depuis le ' + formatFirstDate(daDate) : ''"
    matTooltipPosition="above"
    (click)="daDate && tt.show()">{{ e.label }}</mat-chip>
  }
</div>
}

@let itemsAutonomie = getVisibleItems(onglet?.checkbox_autonomie, autonomieLabels, 'checkbox_autonomie');
@if (itemsAutonomie.length) {
<p class="section-sub-title"><mat-icon>accessibility_new</mat-icon>Autonomie</p>
<div class="chips-block">
  @for (e of itemsAutonomie; track e.key) {
  @let daDate = getFirstDate('checkbox_autonomie', e.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="daDate"
    #tt="matTooltip"
    [matTooltip]="daDate ? 'Depuis le ' + formatFirstDate(daDate) : ''"
    matTooltipPosition="above"
    (click)="daDate && tt.show()">{{ e.label }}</mat-chip>
  }
</div>
}
